import Container, { Service } from 'typedi';
import { TokenType } from '../../../models/enums/general-enums';
import { Utils } from '../../utils';
import { IMigrationAutoLoginModel } from '../models';
import { AutoLoginDataBuilder } from './autologindata.builder.service';

@Service()
export class MigrationAutoLoginDataBuilderService extends AutoLoginDataBuilder<IMigrationAutoLoginModel> {
    private readonly _utils: Utils;

    constructor() {
        super();
        this._utils = Container.get(Utils);
    }

    public Build = async (data: any): Promise<IMigrationAutoLoginModel> => {
        const { productPackage, clientVersion } = this._window.pageContextManager.getDeviceData();
        const { brandId, subBrandId } = this._window.pageContextManager.getBrandData();

        const loginData: IMigrationAutoLoginModel = {
            AuthenticationInfo: JSON.stringify({
                TokenData: {
                    TokenType: TokenType.Migration,
                    TokenValue: data?.token,
                },
                DeviceUUID: data?.businessCorrelationID,
            }),
            BusinessCorrelationID: data?.businessCorrelationID,
            PlayerMigratedCookieExist: data?.playerMigratedCookieExist,
            SourceProductPackage: productPackage,
            BrandID: brandId,
            ClientVersion: clientVersion,
            TargetProductPackage: productPackage,
            TargetSubBrand: subBrandId,
            ...(this.shouldSendLoginCountry() && {
                LoginCountryISO3: this._window.pageContextManager.getGlobalizationData().country,
            }),
        };

        await this._setLoginNativeProps(loginData);
        return loginData;
    };
}
